import { css } from 'styled-components';

const focused = css`
  right: calc(50% - 10vmin);
  width: 20vmin;
  height: 20vmin;
`;

export default focused;
